import React, { useRef } from 'react';
import styled from 'styled-components';
import PlusIcon from '@catalogo/ui-americanas-desktop-svg/plus.svg';
import CheckIcon from '@catalogo/ui-americanas-desktop-svg/checkmark.svg';
import withComboBuyTogether from '@catalogo/service-americanas-product/src/hocs/buy-together';
import AccordionBox from '@catalogo/ui-americanas-mobile-accordion-box-new';
import { formatPrice } from '@catalogo/core-helpers/price';
import ProductCard from './components/product-card';
import Summary from './components/summary';
import { IBuyTogether, IProductCard } from './helpers/interfaces';

export const BuyTogether: React.FC<IBuyTogether> = props => {
  const ref = useRef(null);
  const { mainProduct, products, totalProducts, totalValue, mainPayment, onClickBuyButton } = props;

  const cards = products?.map((product: IProductCard, key: number) => (
    <ProductCard key={product.id} {...product} first={key === 0} />
  ));

  return (
    <AccordionBox
      id="compre-junto"
      title="compre junto"
      htmlElTitle="h2"
      visibilityOnInit={true}
      metricId="compre-junto"
      metricAction="click"
      metricCategory="acordions"
      anchorRef="#compre-junto"
      ref={ref}
      shouldGetElementHeightOnRender={true}
    >
      <Container>
        <MainProductContainer>
          <ImageBox>
            <img alt={mainProduct?.name} src={mainProduct?.image} />
          </ImageBox>
          <InfoBox>
            <ProductName>{mainProduct?.name}</ProductName>
            <Price>R$ {formatPrice(mainPayment?.price)}</Price>
            <ProductLabel>
              <CheckIconUI />
              <Label>produto atual</Label>
            </ProductLabel>
          </InfoBox>
        </MainProductContainer>
        <PlusContainer>
          <PlusIconUI fill="#333" height={26} />
        </PlusContainer>
        <ComboContainer>{cards}</ComboContainer>
        <Summary totalProducts={totalProducts} totalValue={totalValue} onClickBuyButton={onClickBuyButton} />
      </Container>
    </AccordionBox>
  );
};

const Container = styled.div`
  background-color: ${({ theme }) => theme.white};
  display: block;
  justify-content: space-between;
  align-items: center;
  display: block;
  padding: 0;
`;

const PlusContainer = styled.div`
  margin: 10px 0;
  text-align: center;
`;

const PlusIconUI = styled(PlusIcon)`
  &:after {
    content: ' ';
    width: 100%;
    height: 1px;
    position: absolute;
    background: #e5e5e5;
  }
`;

const MainProductContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  img {
    width: 100%;
  }
  width: 100%;
  flex-direction: row;
`;

const Price = styled.p`
  font-weight: bold;
  font-size: 14px;
  color: ${({ theme }) => theme.black};
`;

const Label = styled.i`
  font-size: 14px;
`;

const ProductLabel = styled.div`
  display: flex;
  align-items: center;
  margin-top: 6px;
`;

const CheckIconUI = styled(CheckIcon)`
  fill: ${({ theme }) => theme.primaryColor};
  width: 20px;
  height: 20px;
`;

const InfoBox = styled.div`
  > a > div {
    justify-content: start;
  }
  width: 65%;
  align-self: center;
`;

const ImageBox = styled.div`
  width: 28%;
  margin: 0 5px 0 0;
  min-height: 70px;
`;

const ProductName = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.grey.dark};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
  padding: 0px;
`;

const ComboContainer = styled.div`
  width: 100%;
  display: block;
  flex-direction: column;
  gap: 40px;
  padding: 0;
  flex-wrap: wrap;
`;

export default withComboBuyTogether(BuyTogether);
